import { useEffect } from "react";

// Trava a rolagem da página enquanto uma gaveta ou janela está aberta (no celular,
// sem isso a página de trás rola junto com o toque). Conta quantas travas estão
// ativas, então duas janelas abertas ao mesmo tempo não se soltam uma da outra.
let locks = 0;
let previousOverflow = "";

export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    if (locks === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = previousOverflow;
    };
  }, [locked]);
}
